module.exports = __webpack_public_path__ + "static/media/monkey.8cb12398.svg";